import Button, { ButtonProps } from '../Button';
import Icon, { IconName, IconProps } from '../Icon';

export interface IconButtonProps extends ButtonProps {
  icon: IconName;
  iconProps?: Omit<IconProps, 'icon'>;
}

const IconButton: React.FC<IconButtonProps> = ({ icon, iconProps, ...props }) => (
  <Button as="button" {...props} sx={{ borderRadius: iconProps?.circular ? 'circular' : 'rounded', ...props.sx }}>
    <Icon icon={icon} {...iconProps} />
  </Button>
);

IconButton.defaultProps = {
  variant: 'buttons.icon',
  iconProps: {
    width: 24,
    height: 24
  }
};

export default IconButton;
